// Compact label-over-value stat for the plan page headers (Scope / Target / Period).
export default function HeaderStat({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '.4px', fontWeight: 600, color: 'var(--muted-foreground)' }}>
        {label}
      </div>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--foreground)' }}>{value}</div>
    </div>
  )
}

export function formatStatDate(iso: string): string {
  const [y, m, d] = iso.split('-')
  return `${d}/${m}/${y}`
}
